import { SET_ENABLE_CONTINUE_BTN, SET_DISABLE_CONTINUE_BTN } from './types';

export function setEnableContinueBtn(continueState) {
	return {
		type: SET_ENABLE_CONTINUE_BTN,
		payload: continueState
	};
}
export function setDisableContinueBtn(continueState) {
	return {
		type: SET_DISABLE_CONTINUE_BTN,
		payload: continueState
	};
}
